import ListingProvider from './Listing.provider';

export default ListingProvider;
